import { render, staticRenderFns } from "./NewHome.vue?vue&type=template&id=024628fa&scoped=true"
import script from "./NewHome.vue?vue&type=script&setup=true&lang=js"
export * from "./NewHome.vue?vue&type=script&setup=true&lang=js"
import style0 from "./NewHome.vue?vue&type=style&index=0&id=024628fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024628fa",
  null
  
)

export default component.exports